<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row class="align-items-center">
          <b-col md="2">
            <b-form-input
              v-model="filters.from"
              type="date"
              placeholder="Desde"
            />
          </b-col>
          <b-col md="2">
            <b-form-input
              v-model="filters.to"
              type="date"
              placeholder="Hasta"
            />
          </b-col>
          <b-col md="3">
            <v-select
              v-model="filters.filterColumn"
              :options="filterColumns"
              placeholder="Filtrar por columna"
              :clearable="false"
            />
          </b-col>
          <b-col md="3">
            <b-form-input
              v-model="filters.filterText"
              placeholder="Valor a buscar"
              @keyup.enter="currentPage = 1"
            />
          </b-col>
          <b-col md="3" class="mt-1">
            <v-select
              v-model="filters.companyIds"
              :options="companies"
              label="name"
              :reduce="(c) => c.id"
              placeholder="Empresas"
              multiple
              :clearable="true"
            />
          </b-col>
          <b-col md="2" class="mt-1">
            <b-button
              variant="secondary"
              class="mr-1"
              @click.prevent="clearFilters"
            >
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span class="align-middle">Limpiar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card class="mt-2">
      <div>
        <b-table
          :items="paginatedTransactions"
          :fields="fields"
          striped
          hover
          small
        >
          <!-- Documento: muestra 1 icono por voucher -->
          <template #cell(voucherFile)="row">
            <div v-if="voucherMap[row.item.id]" class="d-flex flex-wrap">
              <b-button
                v-for="voucher in voucherMap[row.item.id]"
                :key="voucher.id"
                variant="link"
                size="sm"
                @click="descargarVoucher(row.item.id, voucher.id)"
                v-b-tooltip.hover
                :title="voucher.originalName"
              >
                <feather-icon icon="FileTextIcon" />
              </b-button>
            </div>
          </template>

          <template #cell(amount)="row">
            <span :class="{ 'text-danger': row.item.amountRaw < 0 }">
              {{ row.item.amount }}
            </span>
          </template>

          <!-- Acciones: subir y eliminar -->
          <template #cell(acciones)="row">
            <b-button
              v-if="puedeAgregarVoucher && (!voucherMap[row.item.id] || voucherMap[row.item.id].length < 3)"
              variant="outline-primary"
              size="sm"
              class="mr-1"
              @click="subirVoucher(row.item.id)"
              v-b-tooltip.hover
              title="Subir voucher"
            >
              <feather-icon icon="UploadIcon" />
            </b-button>

            <b-button
              v-if="
                puedeEliminarVoucher &&
                voucherMap[row.item.id] &&
                voucherMap[row.item.id][0]
              "
              variant="outline-danger"
              size="sm"
              @click="eliminarVoucher(row.item.id)"
              v-b-tooltip.hover
              title="Eliminar voucher"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </template>
        </b-table>

        <div class="d-flex justify-content-between align-items-center mt-2">
          <div class="d-flex align-items-center">
            <label class="mr-1 mb-0">Entradas</label>
            <b-form-select
              v-model="perPage"
              :options="perPageOptions"
              size="sm"
              class="mr-2"
            />
            <span class="text-muted small mb-0"> Registros en total </span>
          </div>

          <b-pagination
            v-model="currentPage"
            :total-rows="filteredTransactions.length"
            :per-page="perPage"
            size="sm"
            align="right"
          />
        </div>
      </div>
    </b-card>

    <b-modal
      v-model="showDeleteModal"
      title="Eliminar Voucher"
      @ok="confirmarEliminarVoucher"
      ok-title="Eliminar"
      cancel-title="Cancelar"
    >
      <div v-if="modalVouchers.length === 0">
        No hay vouchers para eliminar.
      </div>
      <b-form-group v-else>
        <b-form-checkbox-group v-model="selectedVoucherIds" stacked>
          <b-form-checkbox
            v-for="voucher in modalVouchers"
            :key="voucher.id"
            :value="voucher.id"
          >
            {{ voucher.originalName }}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import TransactionService from "@/services/TransactionService";
import FinancialMovementService from "@/services/FinancialMovement";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: { vSelect },
  data() {
    return {
      transactions: [],
      canAdd: false,
      canDelete: false,
      voucherMap: {},
      modalVouchers: [],
      modalTransactionId: null,
      selectedVoucherIds: [],
      showDeleteModal: false,
      companies: [],
      currentPage: 1,
      perPage: 20,
      perPageOptions: [5, 10, 20, 50, 100],
      categories: [
        "Todas",
        "Comisión de Mantenimiento",
        "Comisión de Recaudación",
        "Impuesto ITF",
        "Pago Efectivo",
      ],
      filterColumns: [
        { label: "Descripción", value: "description" },
        { label: "Monto", value: "amount" },
        { label: "Nro. Operación", value: "operationNumber" },
      ],

      filters: {
        from: "",
        to: "",
        companyIds: [],
        filterColumn: null,
        filterText: "",
      },
      fields: [
        { key: "companyName", label: "Empresa", sortable: true },
        { key: "fecha", label: "Fecha", sortable: true },
        { key: "description", label: "Descripción", sortable: true },
        { key: "amount", label: "Monto", sortable: true },
        { key: "balance", label: "Balance", sortable: true },
        { key: "operationNumber", label: "Nro. Operación", sortable: true },
        { key: "voucherFile", label: "Documento", sortable: false },
        //{ key: "hasVoucher", label: "Estado", sortable: false },
        { key: "acciones", label: "Acciones", sortable: false },
      ],
      companyNameMap: {
        "191-2266254-0-53": "GQR Soles",
        "191-2289861-1-17": "GQR Dólares",
        "191-6661536-0-40": "GQR Recaudadora Soles",
        "191-6661491-1-96": "GQR Recaudadora Dólares",
        "191-2545696-0-99": "KONIN Soles",
        "191-2548669-1-39": "KONIN Dólares",
        "191-2358595-0-90": "C&F Soles",
        "191-2443055-1-32": "C&F Dólares",
        "193-9827975-0-72": "NIKKEI Soles",
        "193-9845813-1-64": "NIKKEI Dólares",
      },
    };
  },
  computed: {
    paginatedTransactions() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredTransactions.slice(start, end);
    },
    filteredTransactions() {
      return this.transactions
        .map((tx) => {
          const desc = tx.description || "";
          let categoria = "Otro";
          let descripcionFinal = desc;
          const companyName = this.getCompanyName(
            tx.companyName || tx.company?.name || ""
          );

          if (desc.startsWith("COM.MANTENIM")) {
            categoria = "Comisión de Mantenimiento";
            descripcionFinal = "Comisión de Mantenimiento";
          } else if (desc.startsWith("COMIS.RECAUDACION")) {
            categoria = "Comisión de Recaudación";
            descripcionFinal = "Comisión de Recaudación";
          } else if (desc.includes("IMPUESTO ITF")) {
            categoria = "Impuesto ITF";
            descripcionFinal = "Impuesto ITF";
          } else if (desc.startsWith("EFECTIVO")) {
            categoria = "Pago Efectivo";
            const rucMatch = desc.match(/^EFECTIVO000(\d+)/);
            if (rucMatch) {
              descripcionFinal = `Pago Efectivo - ${rucMatch[1]}`;
            } else {
              descripcionFinal = "Pago Efectivo";
            }
          }

          const fechaCompleta = new Date(tx.date);
          const fecha = `${fechaCompleta
            .getUTCDate()
            .toString()
            .padStart(2, "0")}-${(fechaCompleta.getUTCMonth() + 1)
            .toString()
            .padStart(2, "0")}-${fechaCompleta.getUTCFullYear()} ${
            tx.operationTime
          }`;

          const monto = `${
            tx.currency === "Soles" ? "S/." : "$/."
          }${tx.amount.toFixed(2)}`;
          const balance = `${
            tx.currency === "Soles" ? "S/." : "$/."
          }${tx.balance.toFixed(2)}`;

          return {
            ...tx,
            fecha,
            amount: monto,
            amountRaw: tx.amount,
            balance,
            description: descripcionFinal,
            categoria,
            companyName,
          };
        })
        .filter((tx) => {
          const fechaUTC = new Date(tx.date);

          const fechaSoloUTC = Date.UTC(
            fechaUTC.getUTCFullYear(),
            fechaUTC.getUTCMonth(),
            fechaUTC.getUTCDate()
          );

          const fromUTC = this.filters.from
            ? Date.UTC(
                new Date(this.filters.from).getUTCFullYear(),
                new Date(this.filters.from).getUTCMonth(),
                new Date(this.filters.from).getUTCDate()
              )
            : null;

          const toUTC = this.filters.to
            ? Date.UTC(
                new Date(this.filters.to).getUTCFullYear(),
                new Date(this.filters.to).getUTCMonth(),
                new Date(this.filters.to).getUTCDate()
              )
            : null;

          const inDateRange =
            (!fromUTC || fechaSoloUTC >= fromUTC) &&
            (!toUTC || fechaSoloUTC <= toUTC);

          const inCompany =
            this.filters.companyIds.length === 0 ||
            this.filters.companyIds.includes(tx.companyId);

          let inColumn = true;
          if (this.filters.filterColumn && this.filters.filterText) {
            const col = this.filters.filterColumn.value;
            const val = this.filters.filterText.toLowerCase();

            let columnValue = "";

            if (col === "description") columnValue = tx.description;
            else if (col === "amount") columnValue = tx.amount;
            else if (col === "operationNumber")
              columnValue = tx.operationNumber;

            inColumn =
              columnValue && columnValue.toString().toLowerCase().includes(val);
          }

          return inDateRange && inCompany && inColumn;
        });
    },
  },
  created() {
    const userData = JSON.parse(localStorage.getItem("userData"));

    if (userData?.data?.access?.length) {
      const finanzasList = userData.data.access
        .flatMap((menu) => menu.children)
        .find((child) => child.route === "finanzas-list");

      if (finanzasList) {
        this.puedeAgregarVoucher = finanzasList.canAdd === 1;
        this.puedeEliminarVoucher = finanzasList.canDelete === 1;
      }
    }
  },
  mounted() {
    this.loadCompanies();
    this.getTransactions();
  },
  methods: {
    async loadCompanies() {
      const res = await FinancialMovementService.getUploads(this.$store);
      const seen = new Set();
      this.companies = res
        .map((u) => u.company)
        .filter((c) => c && !seen.has(c.id) && seen.add(c.id))
        .map((c) => ({
          ...c,
          name: this.getCompanyName(c.name),
        }));
    },
    async getTransactions() {
      const res = await TransactionService.getTransactions(this.$store);
      this.transactions = res;
      this.loadVouchersForTransactions();
    },
    getCompanyName(code) {
      return this.companyNameMap[code] || code;
    },
    async loadVouchersForTransactions() {
      for (const tx of this.transactions) {
        if (tx.hasVoucher) {
          const vouchers = await TransactionService.getVouchers(
            tx.id,
            this.$store
          );
          this.$set(this.voucherMap, tx.id, vouchers);
        }
      }
    },
    clearFilters() {
      this.filters.from = "";
      this.filters.to = "";
      this.filters.companyIds = [];
      this.filters.filterColumn = null;
      this.filters.filterText = "";
    },

    subirVoucher(transactionId) {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".pdf,.xls,.xlsx";
      input.multiple = true;
      input.onchange = async () => {
        const files = Array.from(input.files);
        if (!files.length || files.length > 3)
          return this.$toast.error("Máximo 3 archivos permitidos");
        const formData = new FormData();
        files.forEach((f) => formData.append("files", f));
        try {
          await TransactionService.uploadVouchers(
            this.$store,
            transactionId,
            formData
          );
          this.getTransactions();
          this.$toast.success("Vouchers subidos correctamente");
        } catch (e) {
          this.$toast.error("Error al subir vouchers");
        }
      };
      input.click();
    },
    eliminarVoucher(transactionId) {
      this.modalTransactionId = transactionId;
      this.modalVouchers = this.voucherMap[transactionId] || [];
      this.showDeleteModal = true;
    },
    async confirmarEliminarVoucher() {
      if (!this.selectedVoucherIds.length) return;

      try {
        for (const id of this.selectedVoucherIds) {
          await TransactionService.deleteVoucher(
            this.$store,
            this.modalTransactionId,
            id
          );
        }

        const updatedVouchers = await TransactionService.getVouchers(
          this.modalTransactionId,
          this.$store
        );
        this.$set(this.voucherMap, this.modalTransactionId, updatedVouchers);

        this.$toast.success("Vouchers eliminados correctamente");
      } catch (e) {
        this.$toast.error("Error al eliminar vouchers");
      } finally {
        this.showDeleteModal = false;
        this.selectedVoucherIds = [];
      }
    },
    descargarVoucher(transactionId, voucherId) {
      const url = `${process.env.APIURL}transactions/${transactionId}/voucher/${voucherId}`;
      window.open(url, "_blank");
    },
  },
};
</script>
